import { DiscountPopup } from "@/offering_v2/components/discount_popup";
import React, { createContext, useState } from "react";
import { useDiscountPopupFeatureFlag } from "./splitio";

interface DiscountPopupContext {
  setOffset: React.Dispatch<React.SetStateAction<number>>;
}

export const DiscountPopupContext = createContext<DiscountPopupContext>({
  setOffset: () => {},
});

interface DiscountPopupProviderProps {
  children: React.ReactNode;
  partnerId: string;
}

export function DiscountPopupProvider({
  children,
  partnerId,
}: DiscountPopupProviderProps) {
  const discountPopupFeatureFlag = useDiscountPopupFeatureFlag();

  const [offset, setOffset] = useState<number>(0);

  const isDiscountPopupLocalStorageHidden =
    localStorage.getItem(DISCOUNT_POPUP_FB_LOCAL_STORAGE_KEY) === "false";

  return (
    <DiscountPopupContext.Provider value={{ setOffset }}>
      {children}
      {discountPopupFeatureFlag && !isDiscountPopupLocalStorageHidden && (
        <DiscountPopup partnerId={partnerId} offset={offset} />
      )}
    </DiscountPopupContext.Provider>
  );
}

const DISCOUNT_POPUP_FB_LOCAL_STORAGE_KEY = "showDiscountPopupFloatingButton";

export function hideDiscountPopupFBInLocalStorage() {
  localStorage.setItem(DISCOUNT_POPUP_FB_LOCAL_STORAGE_KEY, "false");
}
